'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import posthog from 'posthog-js'
import { CSSProperties, ReactNode } from 'react'

type CTAPlacement = 'banner' | 'corpus' | 'footer'

interface CTALinkProps {
  href: string
  placement: CTAPlacement
  className?: string
  style?: CSSProperties
  target?: string
  children: ReactNode
}

// Thin wrapper around next/link so CTA buttons living in Server Components
// (blog/faq pages export `metadata`, which forbids `'use client'` on the
// page itself) can still report which structural slot they were clicked
// from — the sticky banner, a CTA inside the article body, or the closing
// CTA at the bottom of the page.
export default function CTALink({ href, placement, className, style, target, children }: CTALinkProps) {
  const pathname = usePathname()

  return (
    <Link
      href={href}
      className={className}
      style={style}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : undefined}
      onClick={() => {
        posthog.capture('cta_clicked', {
          placement,
          page: pathname,
          cta_text: typeof children === 'string' ? children : undefined,
        })
      }}
    >
      {children}
    </Link>
  )
}
